<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane label="Staff" name="staff"></el-tab-pane>
      <el-tab-pane label="Community" name="community"></el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-6">
            Recipes
          </div>
          <div class="col-6">
            <recipe-create v-if="$store.getters.isAdmin || $store.getters.isMod" />
          </div>
        </div>
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>User</th>
              <th v-if="$store.getters.isAdmin || $store.getters.isMod">Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recipe in recipes" :key="recipe.id">
              <td>
                <div>
                  <router-link :to="{ name: 'recipes-id', params: { id: recipe.id } }">
                    {{ recipe.title }}
                  </router-link>
                  <span v-if="recipe.status === 'P'" class="badge badge-secondary ml-2">Draft</span>
                </div>
                <div class="text-muted">
                  {{ recipe.dish_types.join(', ') }}
                </div>
              </td>
              <td>
                <router-link :to="{ name: 'users-id', params: { id: recipe.user.id }}">
                  {{ recipe.user.name }}
                </router-link>
                <div class="text-muted">@{{ recipe.user.username }}</div>
              </td>
              <td v-if="$store.getters.isAdmin || $store.getters.isMod">
                <recipe-publish v-if="$store.getters.isAdmin && (recipe.status === 'P' || recipe.status === 'D')" :recipeId="recipe.id" @update="getRecipes" />
                <recipe-view v-if="recipe.status === 'A'" :recipe="recipe" />
                <recipe-nutrient :recipeId="recipe.id" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import RecipeCreate from '@/components/Recipe/RecipeCreate'
import RecipePublish from '@/components/Recipe/RecipePublish'
import RecipeView from '@/components/Recipe/RecipeView'
import RecipeNutrient from '@/components/Recipe/RecipeNutrient'

export default {
  data() {
    return {
      loading: true,
      activePane: 'staff',
      recipes: [],
    }
  },

  components: {
    RecipeCreate,
    RecipePublish,
    RecipeView,
    RecipeNutrient,
  },

  mounted() {
    this.getRecipes()
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getRecipes()
    },

    async getRecipes() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/recipes`, {
          params: {
            all: true,
            community: this.activePane === 'community',
            limit: 512,
          },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.recipes = data.map(item => {
        item.createdAt = moment(item.createdAt).fromNow()
        item.title = item.title || 'N/A'

        return item
      })
    },
  },
}
</script>
